
import axios from "axios";
import {
  useState,
  useEffect
} from "react";
import env from "../config";

const SsoHandler = () => {
  const BASE_URL = `${env.API_URL}/v1`;

  // Static data object as fallback
  // const staticData = {
  //   id: 'O6VwamN8Cz186bZ7rW2V',
  //   userUUID: '6697d0a2a6a7f10715b30a63',
  //   chat_username: 'Matt Spence',
  //   user_email: 'matt@home.cc',
  //   isGHLUser: false,
  //   address: "Abbey",
  //   agenct_config: {
  //     PluginOn: true,
  //     allow: true,
  //     plugins: [],
  //     agent_limit: 250
  //   },
  //   agency_id: "66967f8aa6a7f10715b2f9c8",
  //   agentBuilder: null,
  //   apiKey: "281a34b9-610de430-ac8d0c56",
  //   apps: ['AI Social App'],
  //   assistant_id: "",
  //   assistants: ['asst_LWc3u0XvUUj5zo2yCgcZ9PAj'],
  //   business_name: "Home",
  //   city: "Ledbury",
  //   conversationId: "",
  //   country: "UK",
  //   createdAt: "2024-07-16T14:19:42.278Z",
  //   default_assistant: "",
  //   email: "emo+home@maybetech.com",
  //   first_name: "",
  //   isAuto: true,
  //   is_auto: true,
  //   is_streaming_Api: true,
  //   is_support: null,
  //   last_name: "",
  //   monthly_token_limit: 0,
  //   monthly_token_usage: 0,
  //   nango_connected: false,
  //   onboarding: {
  //     website_url: 'home.cc',
  //     email: 'emo+home@maybetech.com',
  //     verified: true
  //   },
  //   openAgentBuilder: false,
  //   phone_number: "000000000000",
  //   promptlabels_ids: ['671121bc9a1056e380a16efa', '6874e47f6cf74731e30ffb6f'],
  //   selected_assistant_id: null,
  //   state: "Herefordshire",
  //   time_zone: "",
  //   type: "free",
  //   updatedAt: "2025-07-23T17:46:22.182Z",
  //   zip_code: "HR* 1BP",
  //   __v: 0,
  //   _id: "6696817ea6a7f10715b2f9f4"
  // };

  const staticData = {
    id: 'blyeTfqO0X1ZF4JLIUeV',
    userUUID: '689ee37131d7c6f34182e43a',
    chat_username: 'HOME User',
    user_email: 'emo homeproduser@maybetech.com',
    isGHLUser: false,
    address: "",
    agenct_config: {
      PluginOn: true,
      allow: true,
      plugins: [],
      agent_limit: 100
    },
    agency_id: "67e13b8ce6f157d42d5f930e",
    agentBuilder: null,
    apps: ['AI Social App'],
    assistants: [],
    business_name: "HOME",
    city: "",
    conversationId: "",
    country: "",
    createdAt: "2025-08-14T10:19:24.353Z",
    email: "emo+homeprod@maybetech.com",
    first_name: "",
    isAuto: true,
    is_streaming_Api: true,
    is_support: null,
    last_name: "",
    monthly_token_limit: 0,
    monthly_token_usage: 0,
    nango_connected: false,
    number_of_additional_accounts: 0,
    onboarding: {
      website_url: 'www.home.cc',
      email: 'emo+homeprod@maybetech.com',
      verified: true
    },
    openAgentBuilder: false,
    phone_number: "",
    promptlabels_ids: [],
    selected_assistant_id: null,
    state: "",
    time_zone: "Europe/London",
    type: "free",
    updatedAt: "2025-08-18T10:44:01.534Z",
    userId: "689ee37131d7c6f34182e438",
    zip_code: "",
    __v: 0,
    _id: "689db82c982930215d7da4b1"
  };

  // ...existing code...
  const staticDataIframe = {
    id: 'Bgiio44eTEbQjTQy1e3A',
    userUUID: '68f213784deb09185c37957f',
    chat_username: 'Bilal Dev Testing',
    user_email: 'bilal+account4@levelupmarketplace.com',
    isGHLUser: false,
    UserInfo: {
      userName: 'Bilal Dev Testing',
      email: 'bilal+account4@levelupmarketplace.com',
      _id: '68f213784deb09185c37957f',
      userId: '68f213774deb09185c37957d',
    },
    agenct_config: { PluginOn: false, plugins: [] },
    agency_id: '6739f1be347a7f5974735cec',
    agentBuilder: null,
    assistants: [],
    business_name: 'Dev Testing',
    conversationId: '',
    createdAt: '2025-10-17T10:02:11.746Z',
    customer_id: 'cus_TFfxLV0IUmBv4f',
    email: 'bilal+account4@levelupmarketplace.com',
    isAuto: true,
    is_streaming_Api: true,
    is_support: null,
    monthly_token_limit: 100000,
    monthly_token_usage: 4,
    nango_connected: false,
    number_of_additional_accounts: 0,
    number_of_ai_agents: 0,
    number_of_created_agents: 0,
    number_of_team_member: 0,
    number_of_tokens: 1,
    onboarding: { form: [], email: 'sangeeta.m.raghav@gmail.com', verified: true },
    openAgentBuilder: false,
    phone_number: '',
    planType: 'monthly',
    plan_id: '686fdebfe0e47b378ccaad35',
    promptlabels_ids: [],
    selected_assistant_id: null,
    stripe_cst_id: 'cus_TFfxLV0IUmBv4f',
    team_size: 'less-than-10',
    type: 'free',
    unlimited_ai_agents: true,
    updatedAt: '2025-10-17T10:27:36.412Z',
    useAgent: false,
    userId: '68f213774deb09185c37957d',
    zip_code: '',
    __v: 0,
    _id: '68f214234deb09185c3795a8',
  };
  // ...existing code...

  const [ssodata, setssodata] = useState(staticData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Function to get URL parameters
  const getUrlParameter = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  };

  // Function to fetch location data by ID
  const fetchLocationData = async (locationId) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${BASE_URL}/accounts/location?id=${locationId}`);

      if (response?.data?.data) {
        return response.data.data;
      } else {
        throw new Error('No data found for this location ID');
      }
    } catch (error) {
      console.error('Error fetching location data:', error);
      setError(error.message || 'Failed to fetch location data');
      return null;
    } finally {
      setLoading(false);
    }
  };

  const checkSSO = async (app) => {
    console.log('No location ID found in URL parameters, using static data');
    setssodata(window.location.hostname === "iframe.maybedev.ovh" ||
      (window.location.hostname === 'localhost' && window.location.port === '3000') ? staticDataIframe : staticData);
  };

  // Auto-fetch data when component mounts
  useEffect(() => {
    checkSSO();
  }, []);

  return {
    SSO: ssodata,
    checkSSO: checkSSO,
    setssodata,
    loading,
    error
  };
};

export default SsoHandler;